import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn, BeforeInsert, BeforeUpdate } from "typeorm";
import * as bcrypt from 'bcrypt';
import { EmployeeRolesEnum } from "@analytics-soa/shared-models";
import { UserEntity } from "./user.entity";
@Entity('user_to_division_map')
export class UserToDivisionEntity {
    @PrimaryGeneratedColumn('increment', { name: 'id' }) id: number;
    @Column({
        type: 'int',
        nullable: false,
        name: 'division_id'
    })
    divisionId: number;
    
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;
    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    @ManyToOne(() => UserEntity,(user) => user.userToDivisionEntity )
    @JoinColumn({name:'user_id'})
    userId :UserEntity;
}